module.exports = __webpack_public_path__ + "static/img/default-live-no-start-bg.151d0fcd.png";